export default "__VITE_ASSET__DDvFHAAI__"